import Device from "baseStyles/enums/device";
import { SuiStylesType, useSuiStyles } from "baseStyles/useSuiStyles";
import { FlexBoxPropsType } from "schoolUiComponents/basic/Box/FlexBox/types";
import { InputPropsType } from "schoolUiComponents/basic/Input/types";

type PropsType = {}

type StylesType = {
    mainBox: FlexBoxPropsType;
    successPopup: FlexBoxPropsType;
}

const Styles: SuiStylesType<PropsType, StylesType> = {
    [Device.types.Desktop]: ({theme}) => {
        return {
            mainBox: {
                width: 458,
                gap: 24
            },
            successPopupWrap: {
                padding: 32,
            },
            successPopup: {
                width: 552,
            }
        }
    },
    [Device.types.Tablet]: (props) => {
        return {
            mainBox: {
                width: 400,
            },
            successPopupWrap: {
                padding: 24,
            },
            successPopup : {
                width: 320,
            }
        }
    },
    [Device.types.Mobile]: (props) => {
        return {
            mainBox: {
                width: 327,
                // margin: "32px 24px auto 24px"
            },
            successPopupWrap: {
                padding: 20,
            },
            successPopup: {
                width: 303,
            }
        }
    }
}

const ForgetPasswordStyles = useSuiStyles(Styles);

export default ForgetPasswordStyles;